import { AttachmentFolder } from '@/utils/types';

export { AttachmentFolder };

export enum BulkCampaignAction {
  Elect = 'elect',
  Decline = 'decline',
  InitiateMigration = 'initiateMigration',
  CancelMigration = 'cancelMigration',
  Suspend = 'suspend',
  LiftSuspension = 'liftSuspension',
}

export enum CnpCampaignAction {
  None = 'none',
  Elect = 'elect',
  Reject = 'reject',
}
